export function Card({ children, className = '', title }: { children: React.ReactNode; className?: string; title?: string }) {
  return (
    <section className={`rounded-card border border-border bg-white shadow-card ${className}`}>
      {title && <h2 className="border-b border-border px-5 py-3 text-sm font-semibold text-ink">{title}</h2>}
      <div className="p-5">{children}</div>
    </section>
  )
}
